import { render, staticRenderFns } from "./FhMenuFichaAgricola.vue?vue&type=template&id=3372609e&scoped=true&"
import script from "./FhMenuFichaAgricola.vue?vue&type=script&lang=js&"
export * from "./FhMenuFichaAgricola.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3372609e",
  null
  
)

export default component.exports